<template>
  <v-container class="footer-section step">
    <v-row>
      <v-col class="p-0">
        <div class="footer-div" >
            <v-img
            class="footer-logo-img"
              :width="150"
              aspect-ratio="1"
              contain
              :src="require('@/assets/image/logo.png')"
            ></v-img>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style scoped>
.footer-section {
  margin-top: 100px;
  padding: 0!important;
}
.footer-div {
  height: 200px;
  background-color: #b9b9b9;
}
.footer-logo-img {
  margin: auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
</style>